import { UsuarioEnderecos } from "../provider/auth/AuthProps";

export const enderecoService = {
    createEnderecoCompleto: (endereco: UsuarioEnderecos) => {
        const isValid = (value?: string | null): boolean => {
            return value !== null && value !== undefined && value.trim() !== "";
        };

        const cidadeEstado = [
            isValid(endereco.cidade) ? endereco.cidade : null,
            isValid(endereco.estado) ? `(${endereco.estado})` : null
        ]
            .filter(Boolean)
            .join(" ");

        return [
            isValid(endereco.rua) ? `Rua ${endereco.rua}` : null,
            isValid(endereco.quadra) ? `Quadra ${endereco.quadra}` : null,
            isValid(endereco.numero) ? endereco.numero : null,
            isValid(endereco.bairro) ? endereco.bairro : null,
            isValid(cidadeEstado) ? cidadeEstado : null,
            isValid(endereco.cep) ? endereco.cep : null
        ]
            .filter(Boolean)
            .join(", ");
    }
}